import { mintContract } from "../contractor";
import { parseBNBHandle } from "../utils/utils";
import { Toast } from "react-vant";
import {
  useAccount,
  useConnections,
  usePublicClient,
  useWriteContract,
} from "wagmi";
import useConnectBscWallet from "./useConnectBscWallet";
import { useDispatch } from "react-redux";
import { isShowSwitchChainHandler } from "../../store/module/h5.config";
import { useTranslation } from "react-i18next";

const useBscMint = () => {
  const { t, i18n } = useTranslation();
  const { address: account } = useAccount();
  const { balanceData } = useConnectBscWallet();
  const publicClient = usePublicClient();
  const { writeContractAsync } = useWriteContract();
  const connections = useConnections();
  const dispatch = useDispatch();
  const bscMintHandle = async (cardId: number, tokenUrl: string) => {
    if (!account) {
      console.log("Please connect to your wallet");
    } else {
      console.log("mint in wallet");

      if (
        connections.length > 0 &&
        connections[0].chainId != import.meta.env.VITE_BSC_CHAIN_ID
      ) {
        dispatch(isShowSwitchChainHandler(true));
        return;
      }
      const { abi, address }: any = mintContract;
      const value = parseBNBHandle("0.0006"); //附带支付金额0.01BNB
      if (balanceData && balanceData?.value <= value) {
        Toast.fail({
          message: t("h5.text10"),
          forbidClick: true,
          className: "custom-toast",
        });
        return;
      }

      try {
        const hash = await writeContractAsync({
          address,
          abi,
          functionName: "createNFT",
          args: [cardId.toString(), tokenUrl, 500],
          value: value,
        });
        const receipt = await publicClient?.waitForTransactionReceipt({ hash });
        if (receipt && receipt?.status === "success") {
          return hash; // 返回交易哈希
        }
      } catch (e) {
        console.error("Transaction Error:", e);
      }
      //   try {
      //     const _tx = await contract.createNFT(
      //       cardId.toString(), // card id
      //       tokenUrl, // metadata uri
      //       500, // 版税默认500
      //       {
      //         value: value,
      //       }
      //     );
      //     const tx = await _tx.getTransaction();
      //     const receipt = await tx.wait(); // 等待交易确认
      //     console.log("🚀 ~ checkInHandle ~ abs:", receipt);
      //     console.log("🚀 ~ checkInHandle ~ total:", receipt.transactionHash);
      //     return receipt.transactionHash;
      //   } catch (err) {
      //     console.log("��� ~ mintHandle ~ error:", err);
      //   }
    }
  };

  return {
    bscMintHandle,
    account,
  };
};

export default useBscMint;
